import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from '../../node_modules/classnames/index.js';

var CCloseButton = forwardRef(function (_a, ref) {
    var className = _a.className, dark = _a.dark, disabled = _a.disabled, white = _a.white, rest = __rest(_a, ["className", "dark", "disabled", "white"]);
    return (React.createElement("button", __assign({ type: "button", className: classNames('btn', 'btn-close', {
            'btn-close-white': white,
        }, disabled, className), "aria-label": "Close", disabled: disabled }, (dark && { 'data-coreui-theme': 'dark' }), rest, { ref: ref })));
});
CCloseButton.propTypes = {
    className: PropTypes.string,
    dark: PropTypes.bool,
    disabled: PropTypes.bool,
    white: PropTypes.bool,
};
CCloseButton.displayName = 'CCloseButton';

export { CCloseButton };
//# sourceMappingURL=CCloseButton.js.map
